<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="container mt-5">
      <h2 class="text-center mb-4">Consulta de Cobertura</h2>
      <hr />
      <div class="iframe-container card p-3">
        <div v-if="isLoading" class="text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
        </div>
        <iframe
          v-show="!isLoading"
          :src="iframeSrc"
          frameborder="0"
          class="responsive-iframe"
          title="Consulta de Cobertura de Salud - Ministerio de Salud Pública"
          @load="handleIframeLoad"
          @error="handleIframeError"
        ></iframe>
        <div v-if="errorMessage" class="alert alert-danger mt-3" role="alert">
          {{ errorMessage }}
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "ConsultaCobertura",
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      iframeSrc: "https://coberturasalud.msp.gob.ec/",
      isLoading: true,
      errorMessage: "",
    };
  },
  mounted() {
    // Configurar el componente Layout de forma segura
    if (this.$refs.layoutRef) {
      this.$refs.layoutRef.toggleProcesos();
      this.$refs.layoutRef.toggleReportes();
      this.$refs.layoutRef.toggleParametros();
      this.$refs.layoutRef.toggleAyuda();
    }
  },
  methods: {
    handleIframeLoad() {
      // Ocultar el indicador de carga cuando el iframe se carga correctamente
      this.isLoading = false;
      this.errorMessage = "";
    },
    handleIframeError() {
      // Mostrar mensaje de error si el iframe falla al cargar
      this.isLoading = false;
      this.errorMessage = "No se pudo cargar el contenido. Por favor, intenta de nuevo.";
    },
  },
};
</script>

<style scoped>
.iframe-container {
  max-width: 100%;
  background-color: #fff;
}

.responsive-iframe {
  width: 100%;
  height: 60vh; /* Altura responsiva basada en el viewport */
  min-height: 500px; /* Altura mínima para pantallas pequeñas */
  border: none;
}

@media (max-width: 576px) {
  .responsive-iframe {
    height: 50vh;
    min-height: 400px;
  }

  .iframe-container {
    padding: 1rem;
  }
}

.spinner-border {
  width: 2rem;
  height: 2rem;
}

.alert {
  margin-top: 1rem;
}
</style>